import { SubscribeState, Ulid } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { SetCompanySettingsRequest } from "./interfaces";

const DEFAULT_COMPANY_SETTINGS = {
    _id: Ulid.ZERO,
    id: Ulid.ZERO.toString(),
    expense: {
        validate_duplicate: false,
        validate_ocr: false,
    },
    budget: {
        only_external_approval: false,
    },
};

export const makeCompany = ({ connection }: ApiSliceParams) => {
    const store = signal(DEFAULT_COMPANY_SETTINGS);
    const loading = signal(false);
    const loaded = signal(false);
    let started = false;

    const listen = async () => {
        if (started) {
            return;
        }

        const con = connection.value;

        started = true;
        loading.value = true;

        for await (const event of con.company.settings.items()) {
            if (event.kind !== SubscribeState.Remove) {
                event.values.forEach((value) => {
                    const oldValue = store.peek();

                    store.value = {
                        id: value.id.toString(),
                        _id: value.id,
                        expense: {
                            ...oldValue.expense,
                            ...value.expense,
                        },
                        budget: {
                            ...oldValue.budget,
                            ...value.budget,
                        },
                    };
                });
            }

            if (event.kind === SubscribeState.Loaded) {
                loaded.value = true;
                loading.value = false;
            }
        }
    };

    const set = async (request: SetCompanySettingsRequest) => {
        const con = connection.value;

        await con.company.settings.set({
            id: store.peek()._id,
            ...request,
        });
    };

    return {
        store,
        loading,
        listen,
        set,
    };
};
